import React from 'react';
import { Route, Routes } from 'react-router-dom';

import './App.css';

import Home from './pages/Home';
import Publications from './pages/Publications';
import Gallery from './pages/Gallery';
import Tools from './pages/Tools';
import PLANR from './pages/PLANR';
import Page404 from './pages/404';

import NameHeading from './components/name-header';
// import PhotoBar from './components/photo-bar';

const App = () => {
    return (
        <div className="App">
            {/* <PhotoBar /> */}
            <NameHeading />

            <Routes>
                <Route path={`${process.env.PUBLIC_URL}/`} element={<Home />} />
                <Route path={`${process.env.PUBLIC_URL}/publications`} element={<Publications />} />
                <Route path={`${process.env.PUBLIC_URL}/gallery`} element={<Gallery />} />
                <Route path={`${process.env.PUBLIC_URL}/tools`} element={<Tools />} />
                <Route path={`${process.env.PUBLIC_URL}/planr`} element={<PLANR />} />

                <Route path="*" element={<Page404 />} />
            </Routes>
        </div>
    );
};

export default App;
